"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) {
    var _a;
    return ({
        tooltipWrapper: (_a = {
                display: 'flex',
                alignItems: 'center',
                marginLeft: '4px'
            },
            _a["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                position: 'relative',
                '&:hover $hoverMessage': {
                    display: 'block',
                    visibility: 'visible',
                    opacity: 1,
                    overflowWrap: 'break-word'
                }
            },
            _a),
        reveal: {
            position: 'relative',
            '& $hoverMessage': {
                display: 'block',
                visibility: 'visible',
                opacity: '1',
                overflowWrap: 'break-word'
            }
        },
        tooltip: {
            cursor: 'help',
            display: 'flex'
        },
        hoverMessage: {
            background: theme.colors.white,
            border: "1px solid ".concat(theme.colors.gray400),
            color: theme.typography.fontColor.primary,
            opacity: 0,
            padding: 12,
            position: 'absolute',
            textAlign: 'left',
            top: 'calc(100% + 10px)',
            transform: 'translateX(-50%)',
            left: '50%',
            transition: 'opacity .15s ease-out',
            visibility: 'hidden',
            width: 240,
            zIndex: 10,
            '&::before,&::after': {
                content: "''",
                border: 'solid transparent',
                bottom: '100%',
                display: 'inline-block',
                height: 0,
                margin: [0, 'auto'],
                position: 'absolute',
                left: 0,
                right: 0,
                width: 0
            },
            '&::before': {
                borderBottomColor: theme.colors.gray400,
                borderWidth: '10px'
            },
            '&::after': {
                borderBottomColor: theme.colors.white,
                borderWidth: '8px'
            }
        },
        right: {
            left: 'auto',
            transform: 'none',
            right: 'calc(50% - 3.06rem)',
            '&::before,&::after': {
                right: '-60%'
            }
        },
        left: {
            transform: 'none',
            left: 'calc(50% - 3.06rem)',
            '&::before, &::after': {
                right: '60%'
            }
        },
        inlineleft: {
            verticalAlign: 'middle',
            marginRight: theme.spacing('small')
        },
        inlineright: {
            verticalAlign: 'middle',
            marginLeft: theme.spacing('small')
        }
    });
});
